import { useRef, useState, useEffect } from "react";
import Swal from "sweetalert2";
import uploadImg from "../../assets/images/Upload-PNG-Image-File.png";
import { baseURL } from "../../utils/constants";

interface IProps {
  handleFile(file: any | null): void; // Permitir null al eliminar la imagen
  image?: string;
}

export const FileUploader = ({ handleFile, image }: IProps) => {
  const inputFile: any = useRef(null);
  const [imgData, setImgData] = useState<string | null>(null); // Imagen cargada por el usuario
  const [localImage, setLocalImage] = useState<string | null>(image || null); // Imagen inicial

  // Actualizar localImage si image cambia en las props
  useEffect(() => {
    setLocalImage(image || null);
  }, [image]);

  const handleChange = (e: any) => {
    const fileUploaded = e.target.files[0];
    if (fileUploaded.size > 5000000) {
      Swal.fire({
        icon: "error",
        text: "Imagen demasiado grande, asegúrese de subir una menor a 5MB",
      });
      return;
    }

    const reader = new FileReader();
    reader.addEventListener("load", () => {
      setImgData(reader.result as string);
      setLocalImage(null); // Si se sube una imagen, descartamos la original
    });
    reader.readAsDataURL(fileUploaded);
    handleFile(fileUploaded);
  };

  const handleRemove = () => {
    setImgData(null);
    setLocalImage(null);
    handleFile(null); // Notificar al componente padre que se eliminó la imagen
  };

  return (
    <div className="col-6 d-flex flex-column align-items-center">
      {/* Si no hay imagen subida ni imagen inicial, mostrar la imagen por defecto */}
      {!localImage && !imgData && (
        <img
          className="pointer"
          onClick={() => inputFile.current?.click()}
          style={{ width: "40%" }}
          src={uploadImg}
          alt="Subir imagen"
        />
      )}

      {/* Mostrar la imagen cargada o la imagen inicial desde props */}
      {(localImage || imgData) && (
        <img
          className="pointer"
          onClick={() => inputFile.current?.click()}
          style={{ width: "75%" }}
          src={imgData || `${baseURL}${localImage}`}
          alt="Imagen subida"
        />
      )}

      <p onClick={() => inputFile.current?.click()} className="pointer">
        Suba una imagen
      </p>

      {/* Botón para eliminar la imagen */}
      {(localImage || imgData) && (
        <button onClick={handleRemove} className="btn btn-danger mt-2">
          Eliminar imagen
        </button>
      )}

      <input
        type="file"
        accept=".png,.jpg,.gif,.jpeg"
        ref={inputFile}
        style={{ display: "none" }}
        id="file"
        onChange={handleChange}
      />
    </div>
  );
};
